var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signature-pad",attrs:{"id":_vm.id}},[_c('b-button',{staticClass:"signature-pad--btn",on:{"click":_vm.clearSignaturePad}},[_vm._v("Reset")]),_c('VueSignaturePad',{ref:"signaturePadRef",attrs:{"height":"250px","options":_vm.signatureOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }